import { DateTimeOperatorValue } from './../../../misc/saved-searches/models/saved-search.static';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'ssDateTimeLabel', pure: true })
export class SavedSearchDateTimeLabelPipe implements PipeTransform {

    transform(code: string): any {
        if(!code) return null;
        const datetime = DateTimeOperatorValue.find(d=> d.code==code);

        return datetime?.label||code;
    }

 }
